import type { TCreditPurposeFormFields } from 'entities/creditForm';

export const CreditPurposeInfoTexts: Record<keyof TCreditPurposeFormFields, string> = {
  purpose: 'Цель кредита',
  amount: 'Сумма кредита',
  period: 'На срок',
  autoBrand: 'Марка автомобиля',
  autoModel: 'Модель автомобиля',
  autoYear: 'Год выпуска автомобиля',
  initialFee: 'Сумма личных средств',
};

export const CreditCardPurposeInfoTexts: Record<keyof TCreditPurposeFormFields, string> = {
  ...CreditPurposeInfoTexts,
  amount: 'Кредитный лимит',
};

export const CreditPurposeInfoModalTexts = {
  title: 'Цель кредита',
  description: 'Проверьте, что всё верно, и внесите изменения',
};

export const CreditPurposeAmountPeriodBlockTexts = {
  default: 'Сколько вам нужно и на какой срок?',
  creditCard: 'Сколько вам нужно?',
} as const;
